module.exports = __webpack_public_path__ + "static/media/vector.b1e911fb.svg";